import * as React from 'react';

import ArrowRight from '../icons/24/arrow-right';
import Text from '../text';

import { LinkCard as Props } from './link-card.types';

const LinkCard: React.FC<Props> = ({ href, text, title }) => (
  <a className="link-card" href={href}>
    <Text className="link-card__title" size={Text.sizes.basic}>
      {title}
    </Text>
    <div className="link-card__icon">
      <ArrowRight />
    </div>
    {text ? (
      <div className="link-card__text">
        <Text size={Text.sizes.small}>{text}</Text>
      </div>
    ) : null}
  </a>
);

export default LinkCard;
